import type { Middleware } from 'redux';

import { recordFirstTextSent } from '@/components/subcomponents/onboarding/first-text-progress';

import { AppAction } from '../actions';
import { EventTypes } from '../actions/event';

// Keeps the Get Started progress current when a message goes out, instead of waiting for a page load.
// Scheduled messages don't count: the server only marks the first text sent for immediate sends.
export const middleware: Middleware = () => (next) => (action: AppAction) => {
  const result = next(action);
  if (action.type === EventTypes.SEND_MESSAGE_SUCCESS && !action.meta?.scheduledFor) {
    recordFirstTextSent(action.meta?.subdomain);
  }
  return result;
};
